<template>
    <sub-page id="viewPlanRecord" :fullPage="true">
        <div class="plan-detail">
            <div class="user-container">
                <ui-panel class="user-panel" :title="$t('train.trainees')" icon="inuc-members">
                    <div class="search-box">
                        <el-form class="search-box-inner" size="medium">
                            <el-input class="search-item"
                                      v-model="searchName"
                                      @input="searchChange"
                                      :placeholder="$t('tip.usernameOrAccount')"
                                      size="medium" clearable></el-input>
                            <select-multi-orgs
                                class="search-item"
                                v-model="orgIds"
                                @change="searchChange"
                            ></select-multi-orgs>
                            <el-button @click="changeSort" size="medium">
                                <i class="nucfont" :class="sortClass"></i></el-button>
                        </el-form>
                    </div>

                    <ul class="user-list" v-if="userList.length"
                        v-infinite-scroll="load"
                        :infinite-scroll-disabled="page.isLast"
                        :infinite-scroll-immediate="false"
                    >
                        <li class="user-item"
                            v-for="(v, i) in userList"
                            @click="selectUser(v)"
                            :class="{'active': activeID==v.userID}" :key="v.id">
                            <div class="avatar">
                                <img v-if="v.avatar" :src="v.avatar" alt="avatar">
                                <img v-else src="../../assets/images/teacher/avatar_default.png" alt="avatar">
                            </div>
                            <div class="user-info">
                                <p class="user-detail">
                                    <span class="username">{{v.userName}}</span>
                                    <span class="job-num">{{$t('c.NO')}}：{{v.accountNo}}</span>
                                    <span class="job-num">{{$t('c.belong')}}：{{v.orgName}}</span>
                                </p>
                                <div class="user-progress">
                                    <p>{{ $t('train.progress') }}：</p>
                                    <el-progress
                                        :color="v.status === 3 ? '#ec786b' : '#22B9FF'"
                                        :text-inside="true"
                                        :stroke-width="14"
                                        :percentage="(v.percent*100).toFixed(1)"
                                    />
                                </div>
                            </div>
                            <el-button
                                v-if="v.percent !== 1 && userID == creator"
                                class="btn-edit"
                                @click="editUser(v.userID)" type="text"
                            >
                                <i class="nucfont inuc-edit"></i>
                            </el-button>
                        </li>

                        <li v-if="page.isLast">
                            <el-divider style="color:#ccc;">{{$t('c.noMore')}}</el-divider>
                        </li>
                    </ul>

                    <p class="nodata" v-if="!userList.length">{{$t("c.noData")}}</p>
                </ui-panel>
            </div>

            <div class="record-container">
                <ui-panel class="record-panel" :title="activeName+' - '+$t('train.trainTrace')" icon="inuc-folder">
                    <div class="timeline-container">
                        <ul v-if="recordList.length">
                            <template v-for="(item, index) in recordList">
                                <!-- 课件 -->
                                <li class="timeline-block-course" v-if="item.courseName" :key="index">
                                    <div class="timeline-block timeline-course">
                                        <div class="timeline-icon">
                                            <i class="nucfont inuc-folder-ppt"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <h3 class="content-title content-course">课件：{{item.courseName || "-"}}</h3>
                                            <p>{{$t('course.type')}}：{{item.courseTypeName || "-"}}</p>
                                            <div class="process-info">
                                                <p>{{$t('train.progress')}}：</p>
                                                <el-progress :text-inside="true" :stroke-width="14"
                                                             :percentage="(item.percent*100).toFixed(1)"></el-progress>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <!-- 模拟考卷 -->
                                <li class="timeline-block-paper" v-if="item.mockPaperName" :key="index">
                                    <div class="timeline-block timeline-mockPaper">
                                        <div class="timeline-icon ">
                                            <i class="nucfont inuc-mockpaper"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <h3 class="content-title content-mock">模拟考试：{{item.mockPaperName || "-"}}</h3>
                                            <p>{{$t('paper.type')}}：{{item.mockPaperTypeName || "-"}}</p>
                                            <p>{{$t('c.status')}}：{{item.mockExamStatusName || "-"}}</p>
                                            <p>{{$t('paper.mockTimes')}}：{{item.mockExamTimes}}</p>
                                            <a
                                                v-if="item.mockExamTimes"
                                                @click="openMockDetail(item)"
                                                class="btn-view btn-view-mock">{{$t('c.viewDetail')}}</a>
                                        </div>
                                    </div>
                                </li>

                                <!-- 考卷 -->
                                <li class="timeline-block-paper" v-if="item.paperName" :key="index">
                                    <div class="timeline-block timeline-paper">
                                        <div class="timeline-icon">
                                            <i class="nucfont inuc-kaoshijilu"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <h3 class="content-title content-paper">考试：{{item.paperName || "-"}}</h3>
                                            <p>{{$t('paper.type')}}：{{item.paperTypeName || "-"}}</p>
                                            <p>{{$t('c.status')}}：{{item.examStatusName || "-"}}</p>
                                            <p v-if="item.resited">{{$t('paper.resatTimes')}}：{{item.resited}}</p>
                                            <p>{{$t('paper.leaveTimes')}}：{{item.leaveTimes}}</p>
                                            <a
                                                v-if="item.examStatus===2 || item.examStatus === 3"
                                                @click="viewPaper(item)"
                                                class="btn-view">{{$t('stu.viewPaper')}}</a>
                                        </div>
                                    </div>
                                </li>

                                <!-- 调查问卷 -->
                                <li class="timeline-block-course" v-if="item.businessType === 4" :key="index">
                                    <div class="timeline-block timeline-survey">
                                        <div class="timeline-icon">
                                            <i class="nucfont inuc-feedback"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <h3 class="content-title content-course">调查问卷：{{item.businessName || "-"}}</h3>
                                            <p>{{$t('course.type')}}：{{item.businessTypeName || "-"}}</p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </ui-panel>
            </div>
        </div>

        <!-- 请假 -->
        <el-dialog
            :title="$t('c.edit')"
            :visible.sync="editDialog"
            custom-class="edit-dialog"
            width="600px"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
        >
            <el-form
                :model="editForm"
                ref="editForm"
                :rules="editRules"
                label-width="100px">
                <el-form-item :label="$t('train.reason')+'：'" prop="reason">
                    <el-radio v-model="editForm.reason" v-for="item in absenceReason" :label="item.value" :key="item.value">{{item.value}}</el-radio>
                </el-form-item>
                <el-form-item :label="$t('c.desc')+'：'" prop="remark">
                    <el-input type="textarea" v-model="editForm.remark"
                              :autosize="{ minRows: 3, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="saveEditForm" :loading="editLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 模拟练习列表 -->
        <mock-list-dialog
            :dialogOpen.sync="mockDialog"
            :mockItem="mockItem"
            @onViewImgMockPaper="viewImgMockPaper"
        />

        <paper-view
            v-if="paperShow"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        />

        <fiscan-paper
            ref="fiscanPaper"
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            type="exam"
            :usage="2"
        />

        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />

    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage';
    import uiPanel from '@/components/UIPanel';
    import api from '@/api';
    import paperView from '@/components/Paper/PaperView';
    import FiscanPaper from '@components/FiscanPaper';
    import mockListDialog from '@/components/Dialog/MockListDialog'
    import FullScreen from '@/components/FullScreen';
    import selectMultiple from '@/components/Selectmultiple.vue'
    import {Debounce, Ticket, screenfull} from '@/utils';

    export default {
        name: 'PlanRecordDetail',
        components: {
            SubPage,
            uiPanel,
            paperView,
            FullScreen,
            mockListDialog,
            selectMultiple,
            FiscanPaper
        },
        props: ['planId', 'creator'],
        data() {
            return {
                isShow: false,
                src: '',
                searchName: '',
                orgIds: [],
                userList: [],
                recordList: [],
                activeID: '',
                activeName: '',
                page: {
                    pageNo: 1,
                    limit: 20,
                    order: 'Desc',
                    totalPage: 1,
                    isLast: false
                },

                editDialog: false,
                editForm: {
                    reason: '',
                    remark: '',
                },
                editRules: {
                    reason: [
                        {required: true, message: this.$t('tip.reason'), trigger: 'blur'},
                    ],
                    remark: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}
                    ],
                },
                editLoading: false,

                paperShow: false,
                paperInfo: {},
                topicData: [],
                fiscanPaper: {
                    show: false,
                    data: null,
                },

                mockDialog: false,
                mockItem: null,
                absenceReason: []
            }
        },
        computed: {
            userID() {
                return Ticket.get() && Ticket.get().userID
            },
            sortClass() {
                return {
                    Asc: 'inuc-sort-asc',
                    Desc: 'inuc-sort-desc'
                }[this.page.order]
            },
        },
        watch: {
            activeID(val) {
                this.getUserRecord(val);
            },
        },
        mounted() {
            this.getUsers().then(data => {
                if (data && data.length) {
                    this.activeID = data[0].userID;
                    this.activeName = data[0].userName
                }
            })

            this.getAbsenceReason();
        },
        destroyed(){
            this.$emit('onClose');
        },
        methods: {
            load() {
                if (this.page.pageNo >= this.page.totalPage) {
                    this.page.isLast = true
                    return
                }

                this.page.pageNo++

                let queryData = {
                    pageNo: this.page.pageNo,
                    limit: this.page.limit,
                    order: this.page.order,
                    orgIds: this.orgIds,
                    search: this.searchName
                }

                api.getTrainingUsers(this.planId, queryData).then(res => {
                    let data = res.package;
                    this.userList = [...this.userList, ...data];

                    this.page.totalPage = Math.ceil(res.total/this.page.limit)
                });
            },
            getUsers() {
                let queryData = {
                    pageNo: this.page.pageNo,
                    limit: this.page.limit,
                    order: this.page.order,
                    orgIds: this.orgIds,
                    search: this.searchName
                }

                return api.getTrainingUsers(this.planId, queryData).then(res => {
                    let data = res.package;
                    this.userList = data;
                    this.page.totalPage = Math.ceil(res.total/this.page.limit)

                    return data
                });
            },

            searchChange: Debounce(function (val) {
                this.resetInfiniteScroll()
                this.getUsers()
            }, 500),
            changeSort() {
                this.page.order = this.page.order === 'Desc' ? 'Asc': 'Desc'
                this.resetInfiniteScroll()
                this.getUsers()
            },
            resetInfiniteScroll() {
                this.page.pageNo = 1
                this.page.isLast = false
                this.userList = [];
            },

            selectUser({userID, userName}) {
                this.activeID = userID;
                this.activeName = userName
            },
            getUserRecord(userID) {
                api.trainingUserTrace(this.planId, {
                    userID
                }).then(res => {
                    this.recordList = res.package;
                })
            },

            editUser(userID) {
                this.editDialog = true;
                this.$refs['editForm'] && this.$refs['editForm'].resetFields();
                this.currentUserID = userID;
            },
            saveEditForm() {
                this.$refs['editForm'].validate((valid) => {
                    if (!valid) return;

                    this.editLoading = true;
                    api.reviseTraining(this.planId, {
                        userID: this.currentUserID,
                        ...this.editForm
                    }).then(res => {
                        this.editDialog = false;
                        this.editLoading = false;

                        this.$message({
                            message: this.$t('m.editSuccess'),
                            type: 'success'
                        });

                        this.searchChange()

                        // let currentUser = this.allUsers.find(v => v.userID == this.currentUserID);
                        // currentUser.status = 3;
                        // currentUser.statusName = this.$t('train.passiveFinish');
                        // currentUser.percent = 1;
                        // this.searchChange(this.username);
                    }).catch(error => this.editLoading = false);

                });
            },
            // 查看考试作答详情
            viewPaper({paperType, id, examStatus}) {
                if (paperType === 1) {
                    screenfull.request();
                    this.paperShow = true;

                    api.examDetail(id).then(res => {
                        let data = res.package;

                        this.topicData = data.paper.relationship;

                        this.paperInfo = {
                            response: data.records,
                            isSubmit: data.isSubmit,
                            score: data.score,
                            totalSeconds: data.totalSeconds,
                            ...data.paper,
                        };
                    }).catch(error => {
                        this.paperShow = false;
                        screenfull.exit();
                    });
                } else if (paperType === 3 || paperType === 4) {
                    this.isShow = !this.isShow;
                    if (paperType === 4) {
                        this.src = `${api.imagePanoramicHost}/drExamRecord?recordId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=IMAGE_EXAM&examID=${id}&examStatus=${examStatus}`
                    } else {
                        this.src = `${api.imagePanoramicHost}/ctExamRecord?recordId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=IMAGE_EXAM&examID=${id}&examStatus=${examStatus}`
                    }
                    this.$refs.nstswrap.fullScreen()
                } else if (paperType === 5) {
                    // 职鉴
                    this.fiscanPaper.show = true

                    api.examDetail(id).then(res => {
                        this.fiscanPaper.data = res.package
                    }).catch(() => {this.fiscanPaper.show = false})
                }
            },

            // 查看模拟考试详情
            viewImgMockPaper({ paperType, recordId }) {
                this.isShow = !this.isShow
                if (paperType === 4) {
                    this.src = `${api.imagePanoramicHost}/drExamMockRecord?recordId=${recordId}&lang=${this.$i18n.locale}`
                } else {
                    this.src = `${api.imagePanoramicHost}/ctExamMockRecord?recordId=${recordId}&lang=${this.$i18n.locale}`
                }
                this.$refs.nstswrap.fullScreen()
            },

            openMockDetail(item) {
                this.mockDialog = true;
                this.mockItem = item;
            },
            onPaperClose() {
                this.paperShow = false;
            },
            toggleIsShow (val) {
                this.isShow = val;
                this.src = null;
            },
            getAbsenceReason(){
                api.getAbsenceReason().then(res => {
                    this.absenceReason = res.package
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .plan-detail {
        display: flex;
        height: 100%;
    }

    .user-container {
        width: 35%;
    }

    .record-container {
        flex: 1;
        margin-left: 20px;
    }

    .user-panel {
        height: 100%;
        //max-height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;

        .search-box {
            margin: 0 5px;

            .search-box-inner {
                display: flex;
                align-items: center;
            }

            .search-item {
                margin-right: 10px;
                flex: 1;
            }

            /deep/ {
                .el-form-item {
                    margin-bottom: 0;
                }
                .el-form-item__label {
                    display: none;
                }
            }
        }

        .user-list {
            margin: 20px -15px 0 -15px;
            padding: 0 20px;
            overflow: auto;

            .el-divider__text {
                color: #aaa;
            }
        }

        .user-item {
            display: flex;
            position: relative;
            margin-bottom: 10px;
            border: 1px solid #E5E5E5;
            background-color: #fff;
            cursor: pointer;
            transition: border-color .3s;

            .avatar {
                img {
                    width: 80px;
                    height: 80px;
                }
            }

            .btn-edit {
                position: absolute;
                top: 0;
                right: 10px;
                color: #34BEA4;
                display: none;
                &:hover {
                    color: #188ae2;
                }
            }

            &:hover {
                box-shadow: 0 0 10px #e1e0d8;
                .btn-edit {
                    display: block;
                }
            }

            &.active {
                border: 2px solid #22B9FF
            }
        }

        .user-info {
            flex: 1;
            padding: 15px 25px 10px 10px;

            .user-detail {
                //display: flex;
                //flex-wrap: wrap;
                //align-items: center;

                .username {
                    @include no-wrap();
                    display: inline-block;
                    width: 100px;
                    margin-right: 5px;
                    color: #4d4d4d;
                    font-size: 15px;
                    vertical-align: middle;
                }

                .job-num {
                    color: #999;
                    font-size: 12px;
                    vertical-align: middle;
                    &:last-child {
                        margin-left: 10px;
                        @include media-1680 {
                            display: none;
                        }
                    }
                }
            }

            .user-progress {
                display: flex;
                margin-top: 10px;

                > p {
                    margin-right: 5px;
                    font-size: 12px;
                }

                .el-progress {
                    flex: 1;
                }
            }
        }

        .nodata {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #909399;
        }
    }

    .record-panel {
        max-height: 100%;
        display: flex;
        flex-direction: column;
    }

    /*****时间轴****/
    .timeline-container {
        position: relative;
        width: 90%;
        margin: 0 auto;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: -10px;
            left: 26px;
            border-left: 1px dashed #ccc;
        }

        .timeline-block {
            position: relative;
            &:after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 20px;
                width: 12px;
                height: 12px;
                background-color: #fff;
                border: 1px solid #ccc;
                border-radius: 50%;
            }

            .timeline-icon {
                position: absolute;
                top: 50%;
                left: 0;
                width: 56px;
                height: 56px;
                transform: translateY(-50%);
                text-align: center;
                color: #fff;
                border: 3px solid;
                border-radius: 50%;

                > .nucfont {
                    font-size: 24px;
                    vertical-align: -20px;
                }
            }

            .timeline-content {
                position: relative;
                margin-left: 80px;
                padding: 10px 20px;
                background: #fff;
                color: #676a6c;
                border: solid 1px $c-border;
                border-bottom: none;

                > h3 {
                    max-width: 500px;
                    margin-bottom: 5px;
                    font-size: 16px;
                    @include no-wrap;
                }

                p {
                    padding: 5px 0;
                    line-height: 20px;
                    color: #888;
                }

                .process-info {
                    display: flex;

                    .el-progress {
                        flex: 1;
                        padding: 8px 10% 0 10px;
                    }
                }

                &:hover {
                    background-color: #faf9fc;
                    &:after {
                        content: '';
                        position: absolute;
                        top: 42%;
                        right: 100%;
                        height: 0;
                        width: 0;
                        border: 14px solid transparent;
                        border-right: 14px solid #faf9fc;
                    }
                    &:before {
                        content: '';
                        position: absolute;
                        top: 42%;
                        right: 100%;
                        height: 0;
                        width: 0;
                        margin-right: 1px;
                        border: 14px solid transparent;
                        border-right: 14px solid $c-border;
                    }
                }
            }

            .btn-view {
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                @include button-size(4px, 12px, 15px, 0);
                @include button-variant(#fff, #FFB922, #FFB922);
            }

            .btn-view-mock {
                @include button-variant(#fff, $c-mock, $c-mock);
            }
        }

        ul li:last-child {
            .timeline-content {
                border-bottom: 1px solid $c-border;
            }
        }
    }

    .timeline-course {
        .timeline-icon {
            background-color: $c-course;
            border-color: #e0f4ff !important;
        }
        .content-title {
            color: $c-course;
            border-color: mix($c-course, #fff, 20%);
            background-color: mix($c-course, #fff, 10%);
        }
    }

    .timeline-mockPaper {
        .timeline-icon {
            background-color: $c-mock;
            border-color: #c9fdf3 !important;
        }
        .content-title {
            color: $c-mock;
            border-color: mix($c-mock, #fff, 20%);
            background-color: mix($c-mock, #fff, 10%);
        }
    }

    .timeline-paper {
        .timeline-icon {
            background-color: $c-paper;
            border-color: #fff3e6 !important;
        }
        .content-title {
            color: shade($c-paper, 90%);
            border-color: mix($c-paper, #fff, 20%);
            background-color: mix($c-paper, #fff, 10%);
        }
    }

    .timeline-survey {
        .timeline-icon {
            background-color: $c-survey;
            border-color: tint($c-survey, 20%) !important;
        }
        .content-title {
            color: $c-survey;
            border-color: mix($c-survey, #fff, 20%);
            background-color: mix($c-survey, #fff, 10%);
        }
        .timeline-content {
            min-height: 80px;
        }
    }

    .timeline-content {
        .content-title {
            display: inline-block;
            height: 28px;
            padding: 0 10px;
            line-height: 28px;
            text-align: center;
            border: solid 1px #e6e6e6;
            border-radius: 4px;
            background-color: #f4f3f8;
            word-break: break-word;
        }
    }

    .tg-bg {
        color: #fff;
        display: inline-block;
        min-width: 70px;
        text-align: center;
        &.passed {
            background-color: #ffb822;
        }
        &.failed {
            background-color: #f4516c;
        }
    }
</style>

<style lang="scss">
    #viewPlanRecord {

        .user-panel {
            .panel-body {
                display: flex;
                flex-direction: column;
                overflow: hidden;
                background-color: #fff;
            }
        }

        .mock-table {
            margin-bottom: 20px;
        }

        .mock-dialog {
            margin-bottom: 20px;
        }

        .mock-info {
            > span {
                margin-right: 20px;
            }
        }
    }
</style>
